export const MobileMaxWidth = 767;
export const IsMobile = window.innerWidth < MobileMaxWidth;
